import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { getData, API_ENDPOINTS } from "../../services/apiService.js";
import "./Drawer.css";

const drawerWidth = 210;

export default function ClippedDrawer() {
  const sidebarItems = [
    {
      text: "Dashboard",
      path: "dashboard",
      icon: "/smart-vectors/Dashboard.svg",
      activeIcon: "/smart-vectors/Dashboard-Active.svg",
    },
    {
      text: "Packages",
      path: "packages",
      icon: "/smart-vectors/Packages.svg",
      activeIcon: "/smart-vectors/Packages-Active.svg",
    },
    {
      text: "Trips",
      path: "trips",
      icon: "/smart-vectors/Trip.svg",
      activeIcon: "/smart-vectors/Trip-Active.svg",
    },
    {
      text: "Drivers",
      path: "drivers",
      icon: "/smart-vectors/Drivers.svg",
      activeIcon: "/smart-vectors/Drivers-Active.svg",
    },
    {
      text: "Trucks",
      path: "trucks",
      icon: "/smart-vectors/Truck.svg",
      activeIcon: "/smart-vectors/Truck-Active.svg",
    },
    {
      text: "Truck Owners",
      path: "truck-owners",
      icon: "/smart-vectors/Truck-Owner.svg",
      activeIcon: "/smart-vectors/Truck-Owner-Active.svg",
    },
    {
      text: "User",
      path: "users",
      icon: "/smart-vectors/User.svg",
      activeIcon: "/smart-vectors/User-Active.svg",
    },
    {
      text: "Delivery Zones",
      path: "delivery-zones",
      icon: "/smart-vectors/Location-Map.svg",
      activeIcon: "/smart-vectors/Location-Map-Active.svg",
    },
    {
      text: "Settings",
      path: "Settings",
      icon: "/smart-vectors/Settings-Cog.svg",
      activeIcon: "/smart-vectors/Settings-Cog-Active.svg",
    },
    {
      text: "Payments",
      path: "payments",
      icon: "/smart-vectors/Wallet.svg",
      activeIcon: "/smart-vectors/Wallet-Active.svg",
    },
  ];

  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [profilePic, setProfilePic] = useState("/images/Dummy-Image.jpg");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfilePic = async () => {
      const userDataString = localStorage.getItem("userData");
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        const adminId = userData.admin_id;

        if (adminId) {
          try {
            const res = await getData(API_ENDPOINTS.getAdminById, { id: adminId });
            if (res.result && res.result.pic) {
              setProfilePic(res.result.pic);
            }
          } catch (error) {
            console.error("Failed to fetch admin data for header:", error);
          }
        }
      }
    };
    fetchProfilePic();
  }, []);

  const handleOpenLogoutDialog = () => {
    setOpenLogoutDialog(true);
  };

  const handleCloseLogoutDialog = () => {
    setOpenLogoutDialog(false);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("authToken");
    handleCloseLogoutDialog();
    navigate("/");
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        className="header"
      >
        <Toolbar className="navbar">
          <img
            src="/smart-vectors/Truck-App-Logo.svg"
            alt="App Logo"
            style={{ height: "40px" }}
          />
          <ul className="navbar-menu">
            <li>
              <NavLink to="config-panel" style={{ display: "inline-block" }}>
                <img
                  src="/smart-vectors/Settings-Cog.svg"
                  alt="Settings"
                  style={{ cursor: "pointer" }}
                />
              </NavLink>
            </li>
            <li>
              <img src="/smart-vectors/Bell.svg" alt="Notifications" />
            </li>
            <li>
              <NavLink to="profile" style={{ display: "inline-block" }}>
                <img
                  src={profilePic}
                  alt="User Profile"
                  className="img-thumbnail"
                  style={{ cursor: "pointer" }}
                />
              </NavLink>
            </li>
          </ul>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto", flexGrow: 1 }}>
          <List>
            {sidebarItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <NavLink
                  to={item.path}
                  className="sidebar-menu"
                  style={({ isActive }) => ({
                    textDecoration: "none",
                    color: "inherit",
                    width: "100%",
                    display: "block",
                    backgroundColor: isActive ? "#EFF6FFFF" : "transparent",
                  })}
                >
                  {({ isActive }) => (
                    <ListItemButton sx={{ paddingLeft: "20px" }}>
                      {isActive ? (
                        item.activeIcon && (
                          <img
                            src={item.activeIcon}
                            alt={`${item.text} Active Icon`}
                            style={{
                              marginRight: "16px",
                              height: "20px",
                              width: "20px",
                            }}
                          />
                        )
                      ) : (
                        item.icon && (
                          <img
                            src={item.icon}
                            alt={`${item.text} Icon`}
                            style={{
                              marginRight: "16px",
                              height: "20px",
                              width: "20px",
                            }}
                          />
                        )
                      )}
                      <ListItemText
                        primary={item.text}
                        sx={{
                          "& .MuiListItemText-primary": {
                            fontWeight: isActive ? "bold" : "normal",
                            color: isActive ? "primary.main" : "inherit",
                          },
                        }}
                      />
                    </ListItemButton>
                  )}
                </NavLink>
              </ListItem>
            ))}
          </List>
        </Box>
        <Box sx={{ mt: "auto" }}>
          <ListItem disablePadding>
            <ListItemButton
              onClick={handleOpenLogoutDialog}
              sx={{
                paddingLeft: "20px",
                "&:hover": {
                  backgroundColor: "rgba(220, 53, 69, 0.1)",
                },
              }}
            >
              <img
                src="/smart-vectors/Logout.svg"
                alt="Logout Icon"
                style={{ marginRight: "16px", height: "20px", width: "20px" }}
              />
              <ListItemText
                primary="Logout"
                sx={{
                  "& .MuiListItemText-primary": {
                    fontWeight: "500",
                    color: "#4B5563",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
      <Dialog
        open={openLogoutDialog}
        onClose={handleCloseLogoutDialog}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">{"Confirm Logout?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to log out of the application?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLogoutDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmLogout} color="error" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
